
























import {Component, Prop, Vue} from "vue-property-decorator";
import PxTextEntryBox from "@/views/components/input/formFields/PxTextEntryBox.vue";
import PxTextArea from "@/views/components/input/formFields/PxTextArea.vue";
import PxDropdown from "@/views/components/input/formFields/PxDropdown.vue";
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";

import {perRoadStore} from "@/store/store";
import {states} from "@/lib/data/states";
import SeasonRow from "@/modules/perRoad/views/components/SeasonRow.vue";
import {UnitSystem} from "@/interfaces/units";
import RoadwayClassificationEditor from "@/modules/perRoad/views/components/traffic/RoadwayClassificationEditor.vue";
import PrLayerEditor from "@/modules/perRoad/views/components/structure/PrLayerEditor.vue";
import GenericPavementDiagram from "@/modules/design/views/components/GenericPavementDiagram.vue";
import {createPerRoadValidations} from "@/modules/perRoad/lib/validations";
import {IPerRoadLayerBase, IPerRoadLayerImperial, IPerRoadLayerMetric} from "@/modules/perRoad/interfaces/perRoad";

Component.registerHooks(["validations"]);

@Component({
  components: {
    GenericPavementDiagram,
    PrLayerEditor,
    RoadwayClassificationEditor,
    SeasonRow,
    PxNumberInput,
    PxTextEntryBox,
    PxTextArea,
    PxDropdown,
  },
})
export default class PerRoadLayers extends Vue {
  @Prop() readonly id!: string;

  @Prop() readonly page!: number;

  stateOptions = states;

  get scenario() {
    return perRoadStore.currentScenario;
  }

  get scenarioImperial() {
    return perRoadStore.currentImperial;
  }

  get isImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial;
  }

  setLayerAndSync(layerNumber: number, newLayer: IPerRoadLayerImperial | IPerRoadLayerMetric) {
    console.log("Setting new layer", newLayer);
    this.scenario.layers[layerNumber - 1] = newLayer;
    this.sync();
  }

  sync() {
    perRoadStore.setCurrentScenario(this.scenario);
  }

  save() {
    this.sync();
    perRoadStore.saveCurrentScenario();
  }

  validations() {
    return createPerRoadValidations(this.scenarioImperial, this.page);
  }
}

